import './App.css';
import React, { lazy, Suspense } from 'react'
import { Provider } from "react-redux"
import store from "./store";

const AppRouter = lazy(() => import('./routes'))

const App = () => {
  return (
    <Provider store={store}>
      <Suspense fallback={<div className={'text-center mt-5 pt-5'}>Loading Please Wait....</div>}>
        <AppRouter />
      </Suspense>
    </Provider>
  );
}
export default App;

